import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import YearGroupDetails from "Administrator/commonComponents/YearGroupDetails";
export default store => ({
  path: "project-group-setup",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-academicSetup" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [YearGroupDetails(store)],
});
